function generateImageUrls(prefix: string, count: number): string[] {
  const urls = [];
  for (let i = 1; i <= count; i++) {
    urls.push(`assets/img/rooms/${prefix}_${i}.jpg`);
  }
  return urls;
}
export const environment = {
  production: true,
  url: '',
  api_url: 'https://klimontow-booking.virtualreception.pl/api/',
  hotel_name: 'Apartamenty Klimontów',
  privacy_policy: '',
  hotel_rules: 'https://virtualreception.pl/docs/klimontow',
  hotel_url: 'https://aparthouseklimontow.pl/',
  html_title: "Apartamenty Klimontów",
  instagram_url: '',
  facebook_url: '',
  linkedin_url: '',
  asorts: false,
  isBreakfastRequired: false,
  isBreakfastDefaultSelected: false,
  breakfastCheckbox: false,
  localizationSelect: false,
  parkingOptionActive: false,
  rabatInput: true,
  isApart: false,
  minimalStayDays: 1,
  // opcjonalne funkcje do włączenia parametrem
  voucherOptionActive: false,
  offersOptionActive: false,
  breakfastOptionActive: false,
  localChargeOptionActive: false,
  // 
  localCharge: false,
  paymentImagePath: 'assets/img/background.jpg',
  isLanguageChange: false,
  gtm: false,
  gtmtag: '',
  hiddenIcons: false,
  favicon_url: '',
  layoutSettings: {
    footer: {
      addressLine1: 'Apartamenty Klimontów',
      addressLine2: 'ApartHouse ul. Sandomierska 7, 27-640 Klimontów',
    },
  },
  messageForNoRooms: 'Brak pokoi w wybranym terminie',
  roomTypeToImagesMap: {
    "Apartament 4-osobowy Kaszmir": generateImageUrls('Apartament_kaszmir', 10),
    "Apartament 4-osobowy Oliwkowy": generateImageUrls('Apartament_oliwkowy', 13),
    "Apartament 2-osobowy Biały": generateImageUrls('Apartament_bialy', 9),
  },
  cookiesOptionActive: true,
  offersSettings: {},
  roomDetails: false,
  rooms: [{}],
  redirectToOtherHotel: {
    on: false,
    text: ""
  },
  forceBreakfast: false,
};
